var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import { GoogleReCaptcha } from 'react-google-recaptcha-v3';
import { DownloadButton } from "./download-button";
export var DownloadPdf = function (_a) {
    var setGeneratorStep = _a.setGeneratorStep;
    var _b = __read(useState(null), 2), token = _b[0], setToken = _b[1];
    var handleVerify = function (token) {
        setToken(token);
    };
    return (React.createElement("div", { className: "download-pdf" },
        React.createElement("div", { className: "download-pdf__container" }, token == null ? (React.createElement(GoogleReCaptcha, { onVerify: function (token) {
                handleVerify(token);
            } })) : (React.createElement(DownloadButton, { setGeneratorStep: setGeneratorStep, setToken: setToken, token: token })))));
};
